webpackJsonp([131683993344931],{

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n        padding-top: 0;\n    "], ["\n        padding-top: 0;\n    "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n        height: 480px;\n    "], ["\n        height: 480px;\n    "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n        height: 420px;\n    "], ["\n        height: 420px;\n    "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n        height: 235px;\n    "], ["\n        height: 235px;\n    "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n        flex-direction: column;\n        align-items: center;\n    "], ["\n        flex-direction: column;\n        align-items: center;\n    "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n            flex: none;\n            width: 360px;\n            max-width: 100%;\n        "], ["\n            flex: none;\n            width: 360px;\n            max-width: 100%;\n        "]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n            padding-right: 0;\n        "], ["\n            padding-right: 0;\n        "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n            padding-left: 0;\n        "], ["\n            padding-left: 0;\n        "]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n        font-size: 25.5px;\n        line-height: 30px;\n        letter-spacing: -0.4px;\n    "], ["\n        font-size: 25.5px;\n        line-height: 30px;\n        letter-spacing: -0.4px;\n    "]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n        margin-top: 4rem;\n    "], ["\n        margin-top: 4rem;\n    "]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(23);
	
	var _polished = __webpack_require__(12);
	
	var _moment = __webpack_require__(61);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _components = __webpack_require__(11);
	
	var _arrowBack = __webpack_require__(47);
	
	var _arrowBack2 = _interopRequireDefault(_arrowBack);
	
	var _themes = __webpack_require__(15);
	
	var _global = __webpack_require__(6);
	
	var _type = __webpack_require__(10);
	
	var _utils = __webpack_require__(4);
	
	var _colors = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Article = function (_Component) {
	    _inherits(Article, _Component);
	
	    function Article() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Article);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	            data: []
	        }, _this.componentWillMount = function () {
	            var data = _this.props.previewData || _this.props.pathContext;
	
	            _this.setState({
	                data: data
	            });
	        }, _this.renderSections = function () {
	            var data = _this.state.data;
	
	
	            if (data.acf.sections) {
	                return data.acf.sections.map(function (section, i) {
	                    var blocks = section.blocks;
	
	                    if (section.display_section && section.blocks) {
	                        return _react2.default.createElement(_components.Section, {
	                            key: i,
	                            blocks: blocks,
	                            section: section
	                        });
	                    }
	                });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Article.prototype.render = function render() {
	        var data = this.state.data;
	
	
	        if (data) {
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(_components.ScrollProgress, null),
	                _react2.default.createElement(
	                    Wrapper,
	                    null,
	                    _react2.default.createElement(_components.MetaTags, {
	                        title: "Paul Conrad Architects \u2014 Journal : " + data.title,
	                        description: data.acf.listing_description ? data.acf.listing_description : ''
	                    }),
	                    _react2.default.createElement(HeroImage, {
	                        image: data.acf.hero_image.sizes.full_width
	                    }),
	                    _react2.default.createElement(
	                        Opening,
	                        null,
	                        _react2.default.createElement(
	                            Left,
	                            null,
	                            _react2.default.createElement(
	                                Title,
	                                null,
	                                data.title
	                            ),
	                            _react2.default.createElement(
	                                Meta,
	                                null,
	                                _react2.default.createElement(
	                                    CatLink,
	                                    {
	                                        to: "/journal/section/" + data.catSlug
	                                    },
	                                    "" + data.catTitle
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            Right,
	                            null,
	                            _react2.default.createElement(Introduction, {
	                                dangerouslySetInnerHTML: { __html: data.acf.introduction }
	                            })
	                        )
	                    ),
	                    this.renderSections(),
	                    _react2.default.createElement(_components.Footer, {
	                        title: data.title,
	                        pageURL: (0, _utils.isClient)() ? window.location.href : '',
	                        backLink: '/journal',
	                        backLinkText: 'All Posts'
	                    })
	                )
	            );
	        }
	    };
	
	    return Article;
	}(_react.Component);
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	    displayName: "article__Wrapper",
	    componentId: "xvnrkb-0"
	})(["display:flex;flex-direction:column;align-items:center;width:100%;z-index:2;padding-top:10rem;", ""], _utils.media.phone(_templateObject));
	
	// Hero
	
	var HeroImage = _styledComponents2.default.div.withConfig({
	    displayName: "article__HeroImage",
	    componentId: "xvnrkb-1"
	})(["", ";height:600px;margin-bottom:10rem;background-image:url(", ");", " ", " ", " ", ""], _global.innerContainer, function (props) {
	    return props.image;
	}, _global.bgImage, _utils.media.laptop(_templateObject2), _utils.media.tablet(_templateObject3), _utils.media.phone(_templateObject4));
	
	//// article opening
	
	
	// layout
	
	var Left = _styledComponents2.default.div.withConfig({
	    displayName: "article__Left",
	    componentId: "xvnrkb-2"
	})([""]);
	var Right = _styledComponents2.default.div.withConfig({
	    displayName: "article__Right",
	    componentId: "xvnrkb-3"
	})([""]);
	var Meta = _styledComponents2.default.div.withConfig({
	    displayName: "article__Meta",
	    componentId: "xvnrkb-4"
	})(["display:flex;"]);
	
	var Opening = _styledComponents2.default.div.withConfig({
	    displayName: "article__Opening",
	    componentId: "xvnrkb-5"
	})(["", ";display:flex;flex-direction:row;margin-bottom:15rem;", " ", ",", "{flex:50%;box-sizing:border-box;", "}", "{padding-right:2.5rem;", "}", "{padding-left:2.5rem;", "}"], _global.innerContainer, _utils.media.tablet(_templateObject5), Left, Right, _utils.media.tablet(_templateObject6), Left, _utils.media.tablet(_templateObject7), Right, _utils.media.tablet(_templateObject8));
	
	// type styles
	
	var Title = _styledComponents2.default.div.withConfig({
	    displayName: "article__Title",
	    componentId: "xvnrkb-6"
	})(["margin-bottom:2rem;font-family:'Scto';font-weight:300;font-size:34px;line-height:40px;letter-spacing:-0.5px;", ""], _utils.media.laptop(_templateObject9));
	
	var CatLink = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
	    displayName: "article__CatLink",
	    componentId: "xvnrkb-7"
	})(["", ";"], _type.caption);
	
	var Date = _styledComponents2.default.div.withConfig({
	    displayName: "article__Date",
	    componentId: "xvnrkb-8"
	})(["", ";text-indent:0!important;"], _type.caption);
	
	var Introduction = _styledComponents2.default.div.withConfig({
	    displayName: "article__Introduction",
	    componentId: "xvnrkb-9"
	})(["", " &,> *{", ";}"], _utils.media.tablet(_templateObject10), _type.paragraph);
	
	exports.default = Article;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-article-js-2f6466b1fa66f7fa2832.js